import PropTypes from "prop-types";

import GenericValueList from "./helpers/GenericValueList";
import { previewText } from "../../helpers/cellPreview";
import FileIcon from "../../../shared/FileIcon";

function File({ value, options = {} }) {
  return (
    <GenericValueList
      values={value}
      component={(file) => (
        <a
          className="file-link inline-flex items-start gap-1"
          href={`/files/${file.id}`}
          title={file.name}
        >
          {/* the icon box is exactly one text line tall (1lh) with the icon
              centered inside — a wrapping file name keeps the icon centered
              on its FIRST line, while the single-line case renders the same
              as plain items-center did */}
          <span className="flex h-[1lh] flex-none items-center">
            <FileIcon extension={file.extension} className="text-lg" />
          </span>
          <span className="file-name">
            {options.truncate ? previewText(file.name) : file.name}
          </span>
        </a>
      )}
    />
  );
}
File.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      extension: PropTypes.string,
    }),
  ),
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};

export default File;
